import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NoteFormComponent} from './note-form/note-form.component';
import {DialogsModule} from '../../dialogs/dialogs.module';
import {CustomerModule} from '../customer/customer.module';
import {ApiModule} from '../../../api/api.module';
import {FormsModule} from '@angular/forms';
import { NoteComponent } from './note.component';
import {AvatarPlaceholderModule} from "../avatar-placeholder/avatar-placeholder.module";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatMenuModule} from "@angular/material/menu";
import {PipesModule} from "../../pipes/pipes.module";



@NgModule({
  declarations: [NoteFormComponent, NoteComponent],
  exports: [
    NoteFormComponent,
      NoteComponent
  ],
    imports: [
        CommonModule,
        CustomerModule,
        DialogsModule,
        FormsModule,
        AvatarPlaceholderModule,
        MatDatepickerModule,
        MatMenuModule,
        PipesModule
    ]
})
export class NoteModule { }
